var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOther = function SvgOther(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.852 17.734c-1.618 0-2.422-.812-2.422-2.445V3.438c0-1.626.812-2.454 2.422-2.454h3.71c.875 0 1.368.133 1.961.743l4.305 4.382c.625.641.742 1.079.742 2.086v7.094c0 1.625-.804 2.445-2.422 2.445zm.054-1.257h8.18c.812 0 1.226-.43 1.226-1.211V8.25H7.86c-.976 0-1.468-.484-1.468-1.469V2.242H2.914c-.812 0-1.227.446-1.227 1.219v11.805c0 .78.415 1.21 1.22 1.21M8 7.07h4.07l-4.5-4.586v4.149c0 .312.117.437.43.437"
  })));
};
export default SvgOther;